import { Box } from "@mui/material";
import { brainTokens } from "../design/brainTheme";

const c = brainTokens.color;

/** Teal-tint rounded-square monogram — the design's customer avatar. */
export function CustomerAvatar({ name, size = 58 }: { name: string; size?: number }) {
  const letter = (name.trim()[0] ?? "?").toUpperCase();
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${Math.round(size * 0.24)}px`,
        background: c.tealTint,
        color: c.tealInk,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.round(size * 0.45),
        fontWeight: 700,
        flex: "none",
        boxShadow: `inset 0 0 0 1px ${c.tealTintBorder}`,
      }}
    >
      {letter}
    </Box>
  );
}
